import { ComponentsTheme } from '../../../theme';
import { InputSize } from '../types';

const mapInputSizeToThemeSize = (
  size: InputSize = 'large',
): keyof ComponentsTheme['Input']['regular'] => {
  if (size === 'large') {
    return 'big';
  }

  return 'small';
};

export default mapInputSizeToThemeSize;
